$(document).ready(function () {
    $('.slider-for-product').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav-product'
    });
    $('.slider-nav-product').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.slider-for-product',
        dots: false,
        centerMode: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 5
                }
            }
        ]
    });
    // slider for bundbox products
    $('.ingredients_slider').slick({
            infinite: false,
            slidesToShow: 2.5,
            slidesToScroll: 2,
            dots: false,
            arrows: true,
            autoplay: false,
            responsive: [
                { breakpoint: 1251, settings: { slidesToShow: 2 } },
                { breakpoint: 1101, settings: { slidesToShow: 2 } },
                { breakpoint: 750, settings: { slidesToShow: 2 } }
            ]
    });
    $(' .trulyAccordian__toggle').on('click', function () {
            var parent = $(this).closest('.trulyAccordian');
            if (parent.find('.ingredients_slider').length) {
                setTimeout(function () {
                    $('.ingredients_slider').slick('setPosition');
                }, 50);
            }
    });
    // review real slider
    var $slider = $('.real-reviews-slider');
        var $progress = $('.progress');
         $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
            var current = currentSlide ? currentSlide : 0;
            var total = slick.slideCount;
            var percent = ((current + 1) / total) * 100;
            $progress.css('width', percent + '%');
            $progress.attr('aria-valuenow', Math.round(percent));

        });

        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0px',
            dots: false,
            arrows: false,
            infinite: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    // change radion on click
    $('.productbundle_bottlescontent').click(function () {
                $('.productbundle_bottlescontent').removeClass('active');
                $(this).addClass('active');
                $('input[name="choosebottles"]').prop('checked', false);
                $(this).find('input').prop('checked', true);
                let count = parseInt($(this).find('input').val());
                $('.productbundle_giftcard')
                    .removeClass('is-active')
                    .slice(0, count)
                    .addClass('is-active');
                let discount = $(this).data('discount');
                $('#discounted_text').text(discount + '%');
                let discount1 = $(this).data('gift');
                let pricegift = $(this).data('price');
                let subscription_days = $(this).data('days');
                $('#free_discount').text('$'+ pricegift);
                $('#subscription_days').text(subscription_days)
                if (discount1 == 1) {
                    $('#gift_item').text('Free Shipping');
                } else {
                    $('#gift_item').html('<span id="free_gifts">' + discount1 + '</span> Free Gifts');
                }
            });     

    // click on atc button
        // remove old items ajax
          function removeOldItems(keys) {
          var updates = {};
          keys.forEach(function(key) {
              updates[key] = 0; // set lineitme value to zero
          });
          $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: { updates: updates },
              dataType: 'json',
              success: function() {
                  console.log('Old Items are removed');
                  AddtoCart();
              },
              error: function(err) {
                  $('#atc_bundle').addClass('disabled');
                  console.error('Error removing items:', err);
              }
          });
          }
        // remove old itmes ends

        // add to cart
        function AddtoCart() {
        //console.log('change cart running');  
        var selectedQty = parseInt($('.productbundle_bottlescontent input:checked').val());
        var selectedVariantIds = $('.productbundle_bottlescontent input:checked').data('variant-ids');
        var SellingPlanId30 = $('#atc_bundle').data('groupid30days');
        var SellingPlanId60 = $('#atc_bundle').data('groupid60days');
        var PageHandle = window.location.pathname.split('/').pop();
        if (!selectedQty || !selectedVariantIds) return;
        // convert to array
        var variantArray = selectedVariantIds.toString().split(',');
        // Build items array
        var items = variantArray.map(function (id, index) {
        if(PageHandle == 'jelly-booster-limited-time-offer'){
            var item = {
          id: parseInt(id.trim()),
          quantity: index === 0 ? selectedQty : 1,
          properties: index === 0
            ? { _freeShippingProductOffer: 'jellyBoosterPotion' }
            : { _free_with: 'Jelly Booster Pigment Body Potion' }
        };
        }else{
            var item = {
          id: parseInt(id.trim()),
          quantity: index === 0 ? selectedQty : 1,
          properties: index === 0
            ? { _freeShippingProductOffer: 'diamondBabySerum' }
            : { _free_with: 'Diamond Baby Body Serum' }
        };
        }    
        
        // add selling plan only for main product
        if (index === 0 && (selectedQty == 4 || selectedQty == 3)) {
          item.selling_plan = SellingPlanId60;
        }else if (index === 0 && (selectedQty == 1 || selectedQty == 2)) {
          item.selling_plan = SellingPlanId30;
        }
        return item;
        });
        console.log("sditems", items);
        // AJAX Add to Cart
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { items: items },
          dataType: 'json',
          success: function (response) {
            console.log('Added to cart:', response);
            // redirection
            location.href = '/checkout';
          },
          error: function (xhr) {
            $('#atc_bundle').addClass('disabled');
            console.error('Error adding to cart:', xhr.responseText);
          },
        });
      }
      // add to cart ends

      // Change the cart according to requirementes 
        function CartChagne(){
          $.getJSON('/cart.js', function(cart) {
            var itemsToRemove = [];
            cart.items.forEach(function(item) {
                // Find items by property
                console.log(item.properties.Role);
                if (item.properties._free_with === "Diamond Baby Body Serum" || item.properties._freeShippingProductOffer === "diamondBabySerum" || item.properties._free_with === "Jelly Booster Pigment Body Potion" || item.properties._freeShippingProductOffer === "jellyBoosterPotion") {
                     itemsToRemove.push(item.key); // push to array item.key
                }
            });
            if (itemsToRemove.length) {
                //alert("Hello");
                console.log(itemsToRemove);
                removeOldItems(itemsToRemove);
            } else {
              // Add to cart itmes
                //alert("Hello2");
                 AddtoCart();
            }
          });
        }
      // change the cart cods ends
      // atc_bundle buttno clicked  
      $(document).on('click', '#atc_bundle', function (e) {
        e.preventDefault();
        $(this).addClass('disabled');
        $(this).text('Adding To Cart.....');
        CartChagne();
       });
      // atc_bundle buttno clicked ends  
    // ends document.ready functoin

    // sticky button
     const $w = $(window);
        const $sticky = $(".sticky_atc-new");
        const $section = $(".productbundle_section");
        const mq = window.matchMedia("(max-width:768px)");

        function updateSticky() {
            const trigger = $section.offset().top + (mq.matches ? 1400 : 900);
            $sticky.toggleClass("hide", $w.scrollTop() < trigger);
        }

        $w.on("scroll", updateSticky);
        mq.addEventListener("change", updateSticky);
        updateSticky();

        $(document).on("click", ".back-top-text", function (e) {
            e.preventDefault();
            $("html, body").stop().animate({ scrollTop: 0 }, 400);
        });
        $(document).on("click", ".trigger_atc_main", function (e) {
             e.preventDefault();
             $(this).addClass('disabled');
             $(this).text('Adding To Cart.....');
             $("#atc_bundle").trigger('click');
        });

        // Trigger click on initially checked input
        $('.productbundle_bottlescontent')
         .has('input[name="choosebottles"]:checked')
        .trigger('click');

  });        

  // javascript video play pouse functoin
// video play pause function
/*** Video play pause ***/
document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".subscribe-video-wrapper");
    const video = wrapper.querySelector(".video-target");
    const button = wrapper.querySelector(".video-play-pause");
    button.addEventListener("click", function () {
        if (video.paused) {
            video.play();
            button.classList.add("active");
        } else {
            video.pause();
            button.classList.remove("active");
        }
    });
    video.addEventListener("ended", function () {
        button.classList.remove("active");
    });
});   

// faq accordians
document.querySelectorAll(".diamond-faq-question").forEach(btn => {
    btn.addEventListener("click", function () {
        const item = this.parentElement;
        const container = item.parentElement;
        const isActive = item.classList.contains("active");
        container.querySelectorAll(".diamond-faq-item")
            .forEach(el => el.classList.remove("active"));
        if (!isActive) {
            item.classList.add("active");
        }
    });
});

// get full date function
 function getFullDate() {
		var monthNames = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
		var dayNames = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
		var now = new Date();
		now.setDate(now.getDate());
       var english_ordinal_suffix = (now.getDate() % 10 == 1 && now.getDate() != 11 ? 'st' : 
          (now.getDate() % 10 == 2 && now.getDate() != 12 ? 'nd' : 
          (now.getDate() % 10 == 3 && now.getDate() != 13 ? 'rd' : 'th')));
		var nowString =/* dayNames[now.getDay()] + ", " +*/ monthNames[now.getMonth()] + " " + now.getDate()+english_ordinal_suffix /*+ ", " + now.getFullYear()*/;
        var elem = document.getElementById('currentdate');
        if(typeof elem !== 'undefined' && elem !== null) {
            elem.innerHTML = nowString;
        }
    }
if(window.Shopify.routes.root.includes('/es')){
  const escurrentDate = new Date(); // Gets the current date and time
  var elem = document.getElementById('currentdate');
        if(typeof elem !== 'undefined' && elem !== null) {
            elem.innerHTML = escurrentDate.toLocaleDateString('es-ES', { month: 'long',  day: 'numeric' });
        }
}else{
  getFullDate();
}

// rotate card animation
window.addEventListener("load", function () {
if (window.innerWidth > 750) return;
const container = document.querySelector('.clinical-results');
const cards = container.querySelectorAll('.result-card');
const numbers = container.querySelectorAll('.result-card h3');

const config = {
    y: [0, -148, -243, -343],
    r: [3, -2, 2, -3],
    range: 300,
    gap: 10
};
const startOffset = 200;
function scrollReveal() {
    const sY = window.scrollY;
    const cTop = container.getBoundingClientRect().top + sY;
    const wH = window.innerHeight;
    cards.forEach((card, i) => {
        const start = (cTop - wH + (i * 50)) + startOffset;
        const progress = Math.min(Math.max((sY - start) / config.range, 0), 1);
        const targetY = i * config.gap;
        const currentY = (config.y[i] * (1 - progress)) + (targetY * progress);
        card.style.transform = `translateY(${currentY}px) rotate(${config.r[i] * progress}deg)`;
        const num = numbers[i];
        const target = num.dataset.target || (num.dataset.target = parseInt(num.innerText));
        const startVal = 75;
        num.innerText = Math.round(startVal + (progress * (target - startVal))) + "%";
    });
}
window.addEventListener('scroll', scrollReveal);
scrollReveal();
});

window.addEventListener("load", function () {
if (window.innerWidth < 750) return;
const section = document.querySelector(".results-grid");
const firstCard = section.querySelector(".result-card:first-child");
const lastCard = section.querySelector(".result-card:last-child");
const numbers = section.querySelectorAll(".result-card h3");
const firstBaseX = 344.614;
const lastBaseX = -344.217;

const moveStrength = 350;

const firstRotateStrength = -5;  // rotate right
const lastRotateStrength = -4;   // rotate left

let currentProgress = 0;
let targetProgress = 0;

numbers.forEach(num => {
    const targetValue = parseInt(num.innerText);
    num.setAttribute("data-target", targetValue);
    num.innerText = "75%";
});
function updateTarget() {
    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    let progress = (windowHeight - rect.top) / 400;
    targetProgress = Math.max(0, Math.min(1, progress));
}
function animate() {
    currentProgress += (targetProgress - currentProgress) * 0.08;
    const move = currentProgress * moveStrength;
    const firstX = firstBaseX - move;
    const lastX = lastBaseX + move;
    const firstRotation = currentProgress * firstRotateStrength;
    const lastRotation = -currentProgress * lastRotateStrength;
    firstCard.style.transform =
        `translate3d(${firstX}px, 0px, 0px)
    rotate(${firstRotation}deg)
    scale(1.00001)`;
    lastCard.style.transform =
        `translate3d(${lastX}px, 0px, 0px)
    rotate(${lastRotation}deg)
    scale(1.00001)`;
    numbers.forEach(num => {
        const target = Number(num.getAttribute("data-target"));
        if (isNaN(target)) return;
        let value;
        if (currentProgress > 0.995) {
            value = target;
        } else {
            value = Math.round(75 + currentProgress * (target - 75));
        }
        num.innerText = value + "%";
    });
    requestAnimationFrame(animate);
}
window.addEventListener("scroll", updateTarget);
window.addEventListener("resize", updateTarget);
updateTarget();
animate();
});